import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel';

export default class RecipeCarousel {
    private container: HTMLElement;
    private embla: EmblaCarouselType;

    constructor(container: HTMLElement) {
        this.container = container;
        this.embla = EmblaCarousel(container, {
            align: 'start',
            containScroll: 'trimSnaps',
        });
        this.embla.on('select', () => this.updateButton());
        this.button.addEventListener('click', () => {
            this.embla.scrollNext();
        });
        this.updateButton()
    }

    updateButton() {
        this.button.disabled = !this.embla.canScrollNext();
    }

    get button(): HTMLButtonElement {
        const button = this.container.querySelector('button.js-next');

        if (!(button instanceof HTMLButtonElement)) {
            throw new Error('Button not found');
        }

        return button;
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLElement>(selector)).map(container => {
            return new RecipeCarousel(container);
        });
    }
}
